import { useTheme } from "@mui/styles";
import React from "react";

interface SizeProps {
  height?: string;
  width?: string;
  color?: string;
}

export default function TableAddNote(props: SizeProps) {
  const theme = useTheme();
  const primary = theme.palette.primary.main;

  const [colour, setColour] = React.useState<string>("#A3A3A3");
  const handleMouseEnter = () => {
    setColour(primary);
  };
  const handleMouseLeave = () => {
    setColour("#A3A3A3");
  };

  return (
    <svg
      width="27px"
      height="22px"
      viewBox="0 0 27 22"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <g
        id="Designs"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        strokeLinejoin="round"
      >
        <g
          id="Desktop---Transactions:-Trade-Detail---Note-added"
          transform="translate(-1304.000000, -543.000000)"
          stroke={props.color || colour}
          strokeWidth="1.5"
        >
          <g id="Group" transform="translate(220.000000, 354.000000)">
            <g transform="translate(1085.000000, 190.000000)" id="Icons-/-Line-/-Note">
              <path
                d="M2.17400461,20 L2.17400461,20 C0.973340834,20 0,19.026667 0,17.826 L0,12.065 C-0.00105398857,11.8624781 0.0786521609,11.6678856 0.221482499,11.5243041 C0.364312837,11.3807226 0.5584843,11.3 0.761008457,11.3 L4.34800238,11.3 L4.34800238,17.822 C4.34906084,18.3992734 4.12048467,18.953267 3.71266651,19.3618366 C3.30484836,19.7704062 2.75127741,20 2.17400461,20 L2.17400461,20 Z"
                id="Path"
              ></path>
              <path
                d="M4.3479987,12.435 L4.3479987,0.889 C4.3453314,0.655870252 4.43539134,0.431230884 4.59836324,0.264507736 C4.76133514,0.0977845878 4.98386688,0.00263713095 5.21699634,0 L24.1299449,0 C24.3632486,0.00237366831 24.5860369,0.0974052854 24.7492245,0.264157209 C24.9124121,0.430909133 25.0026089,0.655698837 25,0.889 L25,16.667 C25,18.508 23.5399465,20 21.7389514,20 L2.17400461,20"
                id="Path"
              ></path>
              <line
                x1="9.23898539"
                y1="6.957"
                x2="19.0219588"
                y2="6.957"
                id="Path"
                strokeLinecap="round"
              ></line>
              <line
                x1="9.23898539"
                y1="10.761"
                x2="21.1959529"
                y2="10.761"
                id="Path"
                strokeLinecap="round"
              ></line>
              <line
                x1="9.23898539"
                y1="14.565"
                x2="16.8479647"
                y2="14.565"
                id="Path"
                strokeLinecap="round"
              ></line>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
